import { createApi } from "@reduxjs/toolkit/query/react";
import baseQuery from "./baseQuery";
import { API_SERVER } from "../utils/urlBack_End";

export const certificadosDigitalesApi = createApi({
  reducerPath: "certificadosDigitalesApi",
  baseQuery: baseQuery(`${API_SERVER}/certificados`),
  tagTypes: ["CertificadosDigitales"],
  endpoints: (builder) => ({
    // GET /certificados/cliente/:rutCliente/:sucursal
    obtenerCertificadosPorCliente: builder.query({
      query: ({ rutCliente, sucursal }) => `/cliente/${rutCliente}/${sucursal}`,
      transformResponse: (response) => response.data,
      providesTags: (result, error, { rutCliente }) => [
        { type: "CertificadosDigitales", id: rutCliente },
        "CertificadosDigitales",
      ],
    }),

    // GET /certificados/:id/url-prefirmada?sucursal=...
    generarUrlPrefirmada: builder.query({
      query: ({ id, sucursal }) => `/${id}/url-prefirmada?sucursal=${sucursal}`,
      transformResponse: (response) => response.data,
    }),

    // POST /certificados
    crearCertificado: builder.mutation({
      query: (formData) => ({
        url: "/",
        method: "POST",
        body: formData,
      }),
      invalidatesTags: ["CertificadosDigitales"],
    }),

    // PUT /certificados/:id
    actualizarCertificado: builder.mutation({
      query: ({ id, formData }) => ({
        url: `/${id}`,
        method: "PUT",
        body: formData,
      }),
      invalidatesTags: ["CertificadosDigitales"],
    }),

    // DELETE /certificados/:id
    eliminarCertificado: builder.mutation({
      query: ({ id, sucursal }) => ({
        url: `/${id}`,
        method: "DELETE",
        body: { sucursal },
      }),
      invalidatesTags: ["CertificadosDigitales"],
    }),
  }),
});

export const {
  useObtenerCertificadosPorClienteQuery,
  useLazyObtenerCertificadosPorClienteQuery,
  useLazyGenerarUrlPrefirmadaQuery,
  useCrearCertificadoMutation,
  useActualizarCertificadoMutation,
  useEliminarCertificadoMutation,
} = certificadosDigitalesApi;
